import { createPageReader } from '../createPageReader.jsx';
export default createPageReader('RETAIL', 'cart');
